jQuery(function($) {

  // Function for A-Z Directory and Transfer Credit Search
  var filterDirectory = function(predicate) {
    $('.directory__letters').children().remove();

    var currentLetter = null;
    var currentItems  = null;

    var addItems = function() {
      if(currentItems.length > 0 ) {
        var letterHeading = $('<h2></h2>')
        .addClass('directory__letter--heading')
        .text(currentLetter);

        var directoryList = $('<ul></ul>')
        .addClass('directory__list');

        var letterGridColumn = $('<div></div>')
        .addClass('grid__item')
        .addClass('grid__item--3')
        .append(directoryList.clone());

        var letterGrid = $('<div></div>')
        .addClass('grid')
        .append(letterGridColumn.clone())
        .append(letterGridColumn.clone())
        .append(letterGridColumn.clone());

        var columnOneItems = [];
        var columnTwoItems = [];
        var columnThreeItems = [];

        for (var i = 0; i < currentItems.length; i++) {
          if(i % 3 === 0) { // index is even
              columnOneItems.push(currentItems[i]);
          }
          else if(i % 3 === 1) { // index is even
              columnTwoItems.push(currentItems[i]);
          }
          else { // index is even
              columnThreeItems.push(currentItems[i]);
          }
        };



        columnOneItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[0]).children());
        });

        columnTwoItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[1]).children());
        });

        columnThreeItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[2]).children());
        });

        var letterContainer = $('<div></div>')
        .addClass('directory__letter')
        .append(letterHeading)
        .append(letterGrid)
        .appendTo($('.directory__letters'));
      }
    }

    // Creates the directory letters for A-Z directory and transfer credit directory
    $('.directory__list--hidden a').clone().each(function() {
      var item = $(this);
      var firstLetter = item.text().substr(0, 1);

      if(currentLetter != null && currentLetter != firstLetter) {
        addItems();
        currentLetter = null;
      }

      if(currentLetter == null) {
        currentLetter = firstLetter;
        currentItems  = [];
      }

      if(predicate(item)) { currentItems.push(item); }
    });

    if(currentItems && currentItems.length > 0 ) { addItems(); }

    if ($('.directory__letters').children().length === 0) {
      $('.directory__letters').append(
        '<h2 class="directory__letter--no-results">' +
        'No results' +
        '</h2>'
        );
    }
  };

  // Filteres the A-Z Directory via input
  $('.directory__search--input')
  .on('propertychange change click keyup input paste', function() {
    var searchString = $(this).val().toUpperCase();

    letterButtons.removeClass('active');
    filterDirectory(function(item) {
      var itemText = item.text().toUpperCase();
      var check    = itemText.indexOf(searchString);
      return check >= 0
    });
  });

  // Filters A-Z Directory on first letter buttons
  letterButtons = $('.directory__filter--buttons button')
  letterButtons.click(function() {
    $('.directory__search--input').val('');
    letterButtons.removeClass('active');
    $(this).addClass('active');

    if ($(this).text() !== "All") {
      var buttonLetter = $(this).text().toUpperCase();
      filterDirectory(function(item) {
        var firstLetter = item.text().toUpperCase().substr(0, 1);
        return firstLetter == buttonLetter;
      });
    } else {
      filterDirectory(function(item) { return true });
    }


  });

  filterDirectory(function(item) { return true });


  // Function for Faculty and Staff Directory
  var filterStaffDirectory = function(predicate) {
    $('.directory__staff-letters').children().remove();

    var currentLetter = null;
    var currentItems = null;

    var addItems = function() {
      if (currentItems.length > 0) {
        //currentItems = sortArray(currentItems);
        var letterHeading = $('<h2></h2>')
        .addClass('directory__letter--heading')
        .text(currentLetter);

        var directoryWrap = $('<div></div>')
        // .addClass('grid');

        var letterGridColumn = $('<div></div>')
        .addClass('grid__item')
        .addClass('grid__item--2')
        .addClass('grid__item--wide')
        .prepend(directoryWrap.clone());

        var letterGrid = $('<div></div>')
        .addClass('grid')
        .append(letterGridColumn.clone())
        .append(letterGridColumn.clone());

        var columnOneItems = [];
        var columnTwoItems = [];

        for (var i = 0; i < currentItems.length; i++) {
          if(i % 2 === 0) { // index is even
              columnOneItems.push(currentItems[i]);
          }
          else { // index is even
              columnTwoItems.push(currentItems[i]);
          }
        };

        columnOneItems.forEach(function(item) {
          var listItem = $('<div class="grid"></div>').append(item);
          listItem.appendTo($(letterGrid.children()[0]).children());
        });

        columnTwoItems.forEach(function(item) {
          var listItem = $('<div class="grid"></div>').append(item);
          listItem.appendTo($(letterGrid.children()[1]).children());
        });

        var letterContainer = $('<div></div>')
        .addClass('directory__letter')
        .append(letterHeading)
        .append(letterGrid)
        .appendTo($('.directory__staff-letters'));
      }
    }

    // Creates the directory letters for the faculty and staff grid
    $('.directory__staff-list--hidden .grid').clone().each(function() {
      var item = $(this);
      var lastNameLetter = $('.last-name', item).text().substr(0, 1);

      if(currentLetter != null && currentLetter != lastNameLetter) {
        addItems();
        currentLetter = null;
      }

      if(currentLetter == null) {
        currentLetter = lastNameLetter;
        currentItems  = [];
      }

      if(predicate(item)) { currentItems.push(item); }
    });

    if(currentItems && currentItems.length > 0 ) { addItems(); }

    if ($('.directory__staff-letters').children().length === 0) {
      $('.directory__staff-letters').append(
        '<h2 class="directory__letter--no-results">' +
        'No results' +
        '</h2>'
        );
    }
  };

  var sortArray = function(itemArray) {
    itemArray.sort(function (a, b) { return parseInt(a.id) - parseInt(b.id);}).each(function(){
          var elem = $(this);
          elem.remove();
          itemArray.push(elem);
      });
    return itemArray;
  }

  filterStaffDirectory(function(item) { return true });


  // Dynamically add department names to select dropdown from grid list
  var getDeptNames = function() {
    var addedNames = {};

    $('.department-name').each(function() {
      var deptName = $(this).text();
      addedNames[deptName] = true;
    });

    var names = Object.keys(addedNames).sort();

    names.forEach(function(name) {
      var deptOpt = $('<option></option>').text(name);
      $('.department__change').append(deptOpt);
    });
  }

  getDeptNames();





  // Show/hide department contact info
  $('#directorySearch').on('click', function(e) {

    var selection = $('.department__change').val().toLowerCase().replace(' ', '_');

    $('.directory__department').hide();
    $('.directory__department--'+selection).show();


    var firstNameString  = $('#first-name').val().toUpperCase();
    var lastNameString   = $('#last-name').val().toUpperCase();
    var deptString       = $('.department__change option:selected').text().toUpperCase();
    filterStaffDirectory(function(item) {
      var firstItemText = $('.first-name', item).text().toUpperCase();
      var lastItemText  = $('.last-name', item).text().toUpperCase();
      var deptItemText  = $('.department-name', item).text().toUpperCase();
      var checkFirst    = firstItemText.indexOf(firstNameString);
      var checkLast     = lastItemText.indexOf(lastNameString);
      var checkDept     = deptItemText === deptString;
      return checkFirst === 0 && checkLast === 0 && (checkDept || deptString == 'ALL');
    });


    e.preventDefault();
  });

  // Reset Staff Directory search
  $('.clear__filter').click(function(e) {
    $('.department__change').val('All').change();
    $('#first-name, #last-name').val('');
    $('.directory__department').hide();
    filterStaffDirectory(function(item) {
      return true
    });
    e.preventDefault();
  });



  // Function Transfer Credit Search
  var filterCreditDirectory = function(predicate) {
    $('.credit__directory__letters').children().remove();

    var currentLetter = null;
    var currentItems  = null;

    var addItems = function() {
      if(currentItems.length > 0 ) {
        var letterHeading = $('<h2></h2>')
        .addClass('directory__letter--heading')
        .text(currentLetter);

        var directoryList = $('<ul></ul>')
        .addClass('credit__directory__list');

        var letterGridColumn = $('<div></div>')
        .addClass('grid__item')
        .addClass('grid__item--3')
        .append(directoryList.clone());

        var letterGrid = $('<div></div>')
        .addClass('grid')
        .append(letterGridColumn.clone())
        .append(letterGridColumn.clone())
        .append(letterGridColumn.clone());

        var columnOneItems = [];
        var columnTwoItems = [];
        var columnThreeItems = [];

        for (var i = 0; i < currentItems.length; i++) {
          if(i % 3 === 0) { // index is even
              columnOneItems.push(currentItems[i]);
          }
          else if(i % 3 === 1) { // index is even
              columnTwoItems.push(currentItems[i]);
          }
          else { // index is even
              columnThreeItems.push(currentItems[i]);
          }
        };

        columnOneItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[0]).children());
        });

        columnTwoItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[1]).children());
        });

        columnThreeItems.forEach(function(item) {
          var listItem = $('<li></li>').append(item);
          listItem.appendTo($(letterGrid.children()[2]).children());
        });

        var letterContainer = $('<div></div>')
        .addClass('directory__letter')
        .append(letterHeading)
        .append(letterGrid)
        .appendTo($('.credit__directory__letters'));
      }
    }

    // Creates the directory letters for transfer credit directory
    $('.credit__directory__list--hidden a').clone().each(function() {
      var item = $(this);
      var firstLetter = item.text().substr(0, 1);

      if(currentLetter != null && currentLetter != firstLetter) {
        addItems();
        currentLetter = null;
      }

      if(currentLetter == null) {
        currentLetter = firstLetter;
        currentItems  = [];
      }

      if(predicate(item)) { currentItems.push(item); }
    });

    if(currentItems && currentItems.length > 0 ) { addItems(); }

    if ($('.credit__directory__letters').children().length === 0) {
      $('.credit__directory__letters').append(
        '<div class="directory__letter--no-results">' +
        'No results' +
        '</div>'
        );
    }
  };

  // Filters the Transfer Credit Directory via input
  $('.credit__search--input')
  .on('propertychange change click keyup input paste', function() {
    var searchString = $(this).val().toUpperCase();
    letterCreditButtons.removeClass('active');
    filterCreditDirectory(function(item) {
      var itemText = item.text().toUpperCase();
      var check    = itemText.indexOf(searchString);
      return check >= 0
    });
  });

  // Filters Transfer Credit Directory on first letter buttons
  var letterCreditButtons = $('.credit__directory__filter--buttons button');
  letterCreditButtons.click(function() {
    letterCreditButtons.removeClass('active');
    $('.credit__search--input').val('');
    $(this).addClass('active');

    if ($(this).text() !== "All") {
      var buttonLetter = $(this).text().toUpperCase();
      filterCreditDirectory(function(item) {
        var firstLetter = item.text().toUpperCase().substr(0, 1);
        return firstLetter == buttonLetter;
      });
    } else {
      filterCreditDirectory(function(item) { return true });
    }

  });

  filterCreditDirectory(function(item) { return true });

});
